// extracted by mini-css-extract-plugin
export default {"noNetworkContainer":"NoNetworkScreen_noNetworkContainer__isNKQ","icon":"NoNetworkScreen_icon__+mFhO"};